// extracted by mini-css-extract-plugin
module.exports = {"contactPersonsContainer2Column":"ContactPersons_contactPersonsContainer2Column__P3E-C","contactPersonContainer":"ContactPersons_contactPersonContainer__2uEeV"};